import { useState, useEffect } from 'react';
import { IGiftCardProduct } from '../../types';
import * as events from '../../lib/analytics/events';
import { useLocale } from '../../contexts/LocaleContext';
import { getAnalyticsProductPriceInCents } from '../../lib/analytics/analyticsUtils';

export default function useTracking(product: IGiftCardProduct | undefined) {
  const [lastTrackedId, setLastTrackedId] = useState<string | undefined>(undefined);
  const { currency } = useLocale();

  useEffect(() => {
    if (!product || product.id === lastTrackedId) {
      return;
    }

    const eventProperties: events.ProductEventProps = {
      priceInCents: getAnalyticsProductPriceInCents(product, currency),
      productName: product.name,
      sku: product.sku,
      currency,
    };

    if (lastTrackedId) {
      events.giftCardSwitch(eventProperties);
    } else {
      events.giftCardViewed(eventProperties);
    }

    setLastTrackedId(product.id);
  }, [product, lastTrackedId, currency]);
}
